module.exports = __webpack_public_path__ + "static/media/IMG_4781.5a5de3ae.jpg";